import React, { useEffect, useState } from "react";

import { LeadBarStyled } from "./LeadBar.Styles";
import { FlexContainer } from "./../Flex/Flex.Styles";

import { useRecoilValue } from "recoil";
import { leadAtom } from "atoms/lead";
import Search from "./../Search/Search";
import CreateLead from "./../CreateLead/CreateLead";
import searchLead from "api/searchLead";
import Spinner from "components/Spinner/Spinner";
import CallBadge from "./IncomingCallInfo/CallBadge";
import getServicability from "api/getServiceability";
import getContact from "api/getContact";
import createAdditionalProps from "api/createAdditionalProps";
import { useFeatureFlag } from "configcat-react";

interface LeadBarrops {
  setApiError: React.Dispatch<React.SetStateAction<boolean>>;
  setIsServiceability: React.Dispatch<React.SetStateAction<boolean>>;
  setSaveRequestText: React.Dispatch<React.SetStateAction<string>>;
}

const LeadBar = ( props: LeadBarrops): React.JSX.Element => {

  const leadData: any = useRecoilValue(leadAtom);
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState<any>();
  const [parentId, setParentId] = useState<number>();
  const [officeData, setOfficeData] = useState<any>({});
  const [parentLeadData, setParentLeadData] = useState<any>();

  const login = JSON.parse(localStorage.getItem("okta-token-storage") || "{}").idToken?.claims.login;
  const user = { identifier: login, email: login };

  const { value: additionalProperty, loading: additionalPropertyLoading } =
  useFeatureFlag("additionalProperty", false, user as any);
  
  useEffect(() => {
    if(leadData?.postal_code) {
      getOfficeData(leadData?.postal_code);
    }
  }, [leadData?.postal_code]);
  
  useEffect(() => {
    if(officeData) {
      props.setIsServiceability(officeData.is_serviceable);
    }
  }, [officeData]);
  
  useEffect(() => {
    if(leadData) {
      leadData.event_contact_parent_id === null ? setParentId(leadData.contact_id) : setParentId(leadData.event_contact_parent_id);
    }
  });
  
  useEffect(() => {
    parentId && search();
  }, [parentId]);

  useEffect(() => {
    if (leadData && leadData.event_contact_parent_id !== null && parentId) {
      getLeadData();      
    }
  }, [parentId]);

  async function getLeadData () {
    setLoading(true);
    try {
      if(parentId) {
        const leadResponse = await getContact(parentId);
        setParentLeadData({...leadResponse.data });
      }
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  const getOfficeData = async (zip: number) => {
    try {
      if(zip) {
        const res = await getServicability(zip);
        if(res.data) {
          setOfficeData(res.data);
        }
      }
    } catch (error) {
      props.setApiError(true);
      props.setSaveRequestText("Failure to get Office data");
    }
  };

  const search = async () => {
    try {
      setLoading(true);
      const req = await searchLead({
        parent_id: parentId,
      });

      setSearchData(req.data);
      props.setApiError(false);
    } catch (e) {
      props.setSaveRequestText("Failure to get tied accounts");
      props.setApiError(true);
    }

    setLoading(false);
  };

  const createAdditionalProperties = async (contact_id: string | number) => {
    try {
      if (contact_id) {
        const res = await createAdditionalProps(contact_id);
        if (res.data) {
          const newEventId = res.data.event_id;
          const newContactId = res.data.contact_id;
          const leadResponse = await getContact(newContactId);
          if (leadResponse.data) {
            setSearchData((prev: any) => [
              ...prev,
              {
                system_id: leadResponse.data.system_id,
                address_line_1: leadResponse.data.address_line_1,
                city: leadResponse.data.city,
                province: leadResponse.data.province,
                postal_code: leadResponse.data.postal_code,
              },
            ]);
            window.location.replace(`/${newEventId}`);
          }
        }
      }
    } catch (e: any) {
      props.setApiError(true);
      props.setSaveRequestText(String(e.response.data.error));
    }
  };

  const selectOpt = searchData?.map((item: {
    system_id: any;
    address_line_1: any;
    city: any;
    province: any;
    postal_code: any;
  }) => ({
    value: item.system_id,
    label: `${item.address_line_1 ? item.address_line_1 + '.' : ''} 
            ${item.city ? item.city + ',' : ''} 
            ${item.province || ''} 
            ${item.postal_code || 'No Address'}`
  }));

  if (parentLeadData && selectOpt) {
    selectOpt.push({
      value: parentLeadData.event_id,
      label: `${parentLeadData.address_line_1 ? parentLeadData.address_line_1 + '.' : ''} 
              ${parentLeadData.city ? parentLeadData.city + ',' : ''} 
              ${parentLeadData.province || ''} 
              ${parentLeadData.postal_code || 'No Address'}`
    });
  }
  if (selectOpt && additionalProperty && !additionalPropertyLoading) {
    selectOpt.push({
      value: 'Add',
      label: '+ Add New Property',
      disabled: leadData?.pr_customer_id === 0 || leadData?.pr_subscription_id === 0
    });
  }
  const handleSelectChange = (selectedValue: string) => {
    if(selectedValue === "Add") {
      createAdditionalProperties(leadData?.contact_id);
    } else window.location.replace(`/${selectedValue}`);
  };
  let placeHolder = '';
  if(leadData?.event_contact_parent_id === null) {
    placeHolder = `${leadData.address_line_1 ? leadData.address_line_1 + '.' : ""} ${leadData.city ? leadData.city + ',' : ""} ${leadData.province ? leadData.province : ""} ${leadData.postal_code ? leadData.postal_code: "No Address"}`;
  }
  
  return (
    <LeadBarStyled data-testid="lead-bar">
      {loading && <Spinner />}
      <FlexContainer
        className="lead-modal__header"
        justifyContent="space-between"
      >
        <FlexContainer>
          
          {searchData && 
          <CallBadge
            firstName={leadData?.name_first}
            lastName={leadData?.name_last}
            callNumber={leadData?.phone_number}
            customerId={leadData?.pr_customer_id}
            emailAddress={leadData?.email_address}
            subscriptionId={leadData?.pr_subscription_id}
            options={selectOpt || []}
            value={leadData?.system_id}
            handleSelectChange={handleSelectChange}
            placeHolder={placeHolder}
            officeData={officeData}
          />
          }
        </FlexContainer>
        <FlexContainer gap={10} justifyContent="space-between">
          <CreateLead />
          <Search />
        </FlexContainer>
      </FlexContainer>
    </LeadBarStyled>
  );
};

export default LeadBar;
